/*
 * Author: Roger
 * File Created: Thursday, 24-09-19 01:10 pm
 * Last Modified: Thursday, 25-03-06 10:59 am, by Ben Zhao
 */
import { get, post } from '@web/http';

import type { AuthPurpose } from '@/@types/account';
import type { ApplyResponse } from '@/@types/withdraw';

export const withdrawApply = async (_data: {
  network: string;
  coin: string;
  address: string;
  amount: string;
  fee: number;
  who: string;
  purpose: AuthPurpose;
}) => {
  // post: /gateway/private/v1/withdraw/apply
  const { who, purpose, ...rest } = _data;

  return post<ApplyResponse>(`/gateway/withdraw/private/v1/apply`, rest, {
    headers: {
      'x-mfa-who': who,
      'x-mfa-purpose': purpose,
    },
  });
};

export const canWithdraw = async (_params: { asset: string }) => {
  // get: /withdraw/private/v1/canWithdraw?asset=USDC

  return get<boolean>(`/gateway/withdraw/private/v1/canWithdraw`, _params);
};
